import useSWR from 'swr'
import { get } from '@api/apiFetcher'

const API = '/api/user/account_summary'

// Liczby ogłoszeń do menu konta; enabled = false odkłada zapytanie (np. do otwarcia menu w nagłówku).
export default function useAccountSummary (user, enabled = true) {
    const token = user?.token
    const { data } = useSWR(
        enabled && token ? ['account-summary', token] : null,
        () => get({ path: API, auth: token }),
        { dedupingInterval: 60000, revalidateOnFocus: false },
    )
    return data?.success ? data : null
}
